<template>
  <Dialog title="工作模式" :visible.sync="visible" @confirm="confirm">
    <el-form
      class="ac1000-work-mode"
      ref="form"
      label-position="top"
      :model="model"
      label-width="80px"
    >
      <el-form-item>
        <el-select
          v-model="model.mode"
          size="large"
          popper-class="ac1000-select-dropdown"
          placeholder=""
        >
          <el-option
            v-for="item in modeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择风速:" v-if="model.mode === 2">
        <el-radio-group v-model="model.windSpeed">
          <template v-for="item in windSpeedList">
            <el-radio :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="消毒:" v-if="model.mode === 2">
        <el-radio-group v-model="model.disInfect">
          <template v-for="item in disInfectOptions">
            <el-radio :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import Dialog from './Dialog';
import { struct } from '@/utils/transform/index';
import { setAC1000DeviceMode } from '@/api/deviceSetting';

export default {
  components: {
    Dialog
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    },
    ac1000Mod: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      modeList: [
        { label: '自动模式', value: 0 },
        { label: '夜间模式', value: 1 },
        { label: '最爱模式', value: 2 }
      ],
      windSpeedList: [
        { label: '1档', value: 1 },
        { label: '2档', value: 2 },
        { label: '3档', value: 3 },
        { label: '4档', value: 4 },
        { label: '5档', value: 5 },
        { label: '6档', value: 6 }
      ],
      disInfectOptions: [
        { label: '开', value: 1 },
        { label: '关', value: 0 }
      ],
      model: {
        mode: 1,
        windSpeed: 1,
        disInfect: 0
      }
    };
  },
  methods: {
    initData() {
      try {
        const ac1000Mod = this.ac1000Mod;
        const res = struct(ac1000Mod, 'windSpeed,workModel:mode');
        res.windSpeed = res.windSpeed || 1;
        Object.assign(this.model, res);
      } catch (e) {
        console.error(`[ac1000-WORKMODE]-更新model错误`);
      }
    },
    async confirm(loading) {
      loading.show();
      try {
        const requestData = {
          workModel: this.model.mode
        };
        if (this.model.mode === 2) {
          requestData.windSpeed = this.model.windSpeed;
        }

        await setAC1000DeviceMode({
          sn: this.sn,
          code: this.model.mode,
          disInfect: this.model.disInfect,
          windSpeed: this.model.windSpeed
        });

        this.$message.success('设置成功');
        this.hide();
      } catch (error) {
        console.error('[AC1000-SET_WORKMODE]: ', error);
      } finally {
        loading.hide();
      }
    },
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  },
  watch: {
    visible(n) {
      if (!n) return;
      this.initData();
    }
  }
};
</script>

<style lang="scss">
.ac1000-select-dropdown {
  background: #fff;
  border: 1px solid #fff;

  .el-select-dropdown__item {
    color: #333333;
    font-size: 26px;
    line-height: 42px;
    height: 42px;

    &.selected {
      color: #49c7c3;
    }
    &.hover {
      background: #ccc;
    }
  }
  .popper__arrow {
    border-bottom-color: #fff !important;
    &::after {
      border-bottom-color: #fff !important;
    }
  }
}
.ac1000-work-mode {
  padding: 0 4em;

  .el-form-item__label {
    font-size: 2.25em;
    color: #000;
    padding: unset;
    margin-bottom: 0.5em;
  }

  .el-form-item__content {
    color: #000;
  }
  .el-radio-group {
    font-size: 2.25em;
    .el-radio {
      color: #000;
      font-size: 1em;

      .el-radio__inner {
        width: 1em;
        height: 1em;
        border-color: #000;
        background: #fff;

        &::after {
          width: 0.5em;
          height: 0.5em;
        }
      }

      .el-radio__label {
        font-size: 1em;
      }

      .el-radio__input.is-checked .el-radio__inner {
        border-color: #000;
        background: #fff;
      }

      .el-radio__input.is-checked + .el-radio__label {
        color: #000;
      }
    }
  }
  .el-input {
    font-size: 2.25em;
  }

  .el-select {
    .el-input__inner {
      background-color: #fff;
      color: #000;
      height: 2.25em;
    }

    .el-select__caret {
      color: #000;
      font-size: 1em;
      width: 1em;
    }
  }
}
</style>
